import React, { memo } from 'react'
import tw from 'twin.macro'
import { ChevronLeftMinor, ChevronRightMinor, QuestionMarkMajor } from '@shopify/polaris-icons'
import { Typography, Button as MUIButton } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { Menu } from 'src/components/settings/Menu'

interface Props {
  modalContainerRef: React.RefObject<HTMLDivElement>
  hideSettings?: boolean
  handleGetHelp: () => void
  onBack?: () => void
  onSkip?: () => void
  handleBack: () => void
}

const ClientStepsHeaderComponent = ({
  modalContainerRef,
  hideSettings,
  handleGetHelp,
  onBack,
  onSkip,
  handleBack,
}: Props) => {
  return (
    <div
      css={tw`bg-shades-0 h-16 p-4 [box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07)] top-0 w-full flex items-center justify-between`}
    >
      <MUIButton
        variant="contained"
        color="secondary"
        onClick={onBack || handleBack}
        css={tw`bg-shades-100 hover:bg-gray-200 h-[42px]`}
      >
        <div css={tw`items-center flex flex-row`}>
          <ChevronLeftMinor width={20} />
          <Typography css={tw`text-shades-1000 [font-weight: 600]`}>Dashboard</Typography>
        </div>
      </MUIButton>
      {!hideSettings && (
        <div css={tw`flex-row flex gap-2`}>
          <Button
            className={tw`w-[120px] px-3`}
            rightIcon={<QuestionMarkMajor css={tw`fill-primary-500`} width={20} height={20} />}
            onClick={handleGetHelp}
            color="light"
            size="medium"
          >
            Get Help
          </Button>
          <Menu flow="client" variant="light" modalContainerRef={modalContainerRef} />
        </div>
      )}
      {onSkip && (
        <MUIButton
          variant="contained"
          color="secondary"
          onClick={onSkip}
          css={tw`bg-primary-100 hover:bg-primary-200 h-[42px]`}
        >
          <div css={tw`items-center flex flex-row`}>
            <Typography css={tw`text-primary-500 [font-weight: 600]`}>Skip step</Typography>
            <ChevronRightMinor css={tw`fill-primary-500`} width={20} />
          </div>
        </MUIButton>
      )}
    </div>
  )
}

export const ClientStepsHeader = memo(ClientStepsHeaderComponent)
